const NoSidebar = () => null;

export default NoSidebar;
